import { createContext, useCallback, useEffect, useState } from 'react';

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    // Determine initial state based on window width
    const [isOpen, setIsOpen] = useState(() => {
        return window.innerWidth >= 768; // Start collapsed on mobile, expanded on desktop
    });

    const toggleSidebar = useCallback(() => {
        setIsOpen((prev) => {
            const newState = !prev;
            const isMobile = window.innerWidth < 768;

            // Sync with DOM classes as the template relies on them
            const mainWrapper = document.getElementById('main-wrapper');
            if (mainWrapper) {
                if (isMobile) {
                    // Mobile: menu-toggle means OPEN
                    if (newState) mainWrapper.classList.add('menu-toggle');
                    else mainWrapper.classList.remove('menu-toggle');
                } else {
                    // Desktop: menu-toggle means COMPRESSED
                    if (newState) mainWrapper.classList.remove('menu-toggle');
                    else mainWrapper.classList.add('menu-toggle');
                }
            }

            return newState;
        });
    }, []);

    // Also handle initial sync and window resize or state changes
    useEffect(() => {
        const mainWrapper = document.getElementById('main-wrapper');
        const isMobile = window.innerWidth < 768;
        if (mainWrapper) {
            if (isMobile) {
                if (isOpen) mainWrapper.classList.add('menu-toggle');
                else mainWrapper.classList.remove('menu-toggle');
            } else {
                if (isOpen) mainWrapper.classList.remove('menu-toggle');
                else mainWrapper.classList.add('menu-toggle');
            }
        }
    }, [isOpen]);

    return (
        <SidebarContext.Provider value={{ isOpen, toggleSidebar, setIsOpen }}>
            {children}
        </SidebarContext.Provider>
    );
};
